/**
 * Investor demo theme constants.
 * Extends the core Vortx theme for the cinematic dark demo experience.
 */
import { vortxColors, vortxTypography, retroColors, chartColors } from '@vortx/shared-ui';

// Re-export retroColors from shared-ui (single source of truth)
export { retroColors };

export const demoColors = {
    // Act-specific accent colors
    actShift: vortxColors.gold,         // Act 1: The Shift
    actPlatform: retroColors.accent,    // Act 2: The Platform
    actDepth: chartColors.hvac,         // Act 3: The Depth (purple)
    actBusiness: vortxColors.gold,      // Act 4: The Business

    // Stat colors
    statHighlight: vortxColors.gold,
    statSecondary: retroColors.accent,
    statMuted: retroColors.muted,

    // Revenue streams
    devFee: vortxColors.gold,
    fluxSaas: retroColors.accent,
    assetMgmt: chartColors.hvac,
};

export const demoTypography = {
    // Step titles — large, impactful
    stepTitle: {
        fontFamily: vortxTypography.heading,
        fontWeight: 700,
        fontSize: { xs: '1.8rem', md: '2.4rem', lg: '3rem' },
        lineHeight: 1.2,
        color: vortxColors.white,
    },
    // Step subtitle
    stepSubtitle: {
        fontFamily: vortxTypography.body,
        fontSize: { xs: '1rem', md: '1.2rem' },
        lineHeight: 1.6,
        color: retroColors.dimmed,
    },
    // Quote/callout text
    quote: {
        fontFamily: vortxTypography.body,
        fontSize: { xs: '1.1rem', md: '1.3rem' },
        fontStyle: 'italic',
        lineHeight: 1.5,
        color: vortxColors.white,
    },
    // Technical "behind the scenes" text
    technical: {
        fontFamily: vortxTypography.mono,
        fontSize: '0.8rem',
        lineHeight: 1.6,
        color: retroColors.accent,
    },
    // Key stat number
    statNumber: {
        fontFamily: vortxTypography.mono,
        fontWeight: 700,
        fontSize: { xs: '2rem', md: '3rem', lg: '3.5rem' },
        lineHeight: 1,
        color: vortxColors.gold,
    },
    // Key stat label
    statLabel: {
        fontFamily: vortxTypography.body,
        fontSize: '0.85rem',
        color: retroColors.muted,
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
    },
};
